import { render, staticRenderFns } from "./EmploymentVCR.vue?vue&type=template&id=40e95e72&scoped=true&"
import script from "./EmploymentVCR.vue?vue&type=script&lang=ts&"
export * from "./EmploymentVCR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e95e72",
  null
  
)

export default component.exports